<template lang="pug">
div
  Form(:data="crime", :isSubmitting="isSubmitting", @submit="create")
</template>

<script>
import Form from '../shared/Form.vue'
import useCrimeAdd from './useCrimeAdd'

export default {
  components: {
    Form,
  },

  setup() {
    const { create, crime, isSubmitting } = useCrimeAdd()

    return {
      crime,
      create,
      isSubmitting,
    }
  },
}
</script>
